"use strict";

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var iteratePrototypeChain;

exports.default = iteratePrototypeChain = function (obj, func) {
  var proto;
  proto = Object.getPrototypeOf(obj);
  while (proto !== null && proto.constructor !== Object) {
    func(proto, obj);
    proto = Object.getPrototypeOf(proto);
  }
};